import { FileUpload } from "../../models/Entities/Contracts/FileUpload";
import { AppState } from "../../redux/reducers";
import { connect } from "react-redux";

export interface IProps {
  isOpen: boolean;
  file?: FileUpload;
  onClose: () => void;
}

interface StateProps {
  accessToken?: string;
}

export type Props = IProps & StateProps;

export const mapStateToProps = (state: AppState): StateProps => ({
  accessToken: state.oidc?.user?.access_token,
});

export const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps);
